import React from "react";

import "./Circle.css";

function Circle({ active }) {
  return <span className={`circle ${active ? "active" : "inactive"}`}></span>;
}

export default Circle;
